import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UserListItem } from '../models/user-list.model';
import { UserDetail } from '../models/user-detail';
import { UserUpdate } from '../models/user-update.model';
import { EntityService } from 'src/app/core/services/entity.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends EntityService<UserDetail, UserListItem, UserUpdate, UserUpdate> {

  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/user');
  }
}
